<template>
  <div v-if="getEnableWalkScore">
    <slot />
    <div class="walk-score">
      <app-walk-score
        :wsId="wsId"
        :address="address"
      />
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

  import config from '@/config'
  import WalkScore from '@/components/walkScore/walkScore.vue'

  export default {
    components: {
      appWalkScore: WalkScore
    },
    data () {
      return {
        wsId: config.WALK_SCORE_ID
      }
    },
    computed: {
      ...mapState('tours', ['walkScore']),
      ...mapGetters('tour', ['getEnableWalkScore']),
      address () {
        return this.walkScore.address
      }
    }
  }
</script>

<style lang="scss">
  .walk-score {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }
</style>
